module.exports = __webpack_public_path__ + "img/zx5.bc5af7ea.png";